import { render, staticRenderFns } from "./CustomHeaderSort.vue?vue&type=template&id=4cce8c88&scoped=true"
import script from "./CustomHeaderSort.vue?vue&type=script&lang=ts"
export * from "./CustomHeaderSort.vue?vue&type=script&lang=ts"
import style0 from "./CustomHeaderSort.vue?vue&type=style&index=0&id=4cce8c88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4cce8c88",
  null
  
)

export default component.exports